import { AlertManager } from 'react-alert'
import { GeneralStore, GENERAL_STORE, UserStore, USER_STORE } from 'store'
import { FormConstraints } from 'utilities'

export type LoginPageProps = {
  [GENERAL_STORE]?: GeneralStore
  [USER_STORE]?: UserStore
  alert: AlertManager
}

export type LoginForm = {
  emailAddress: string
  password: string
  toucheBackofficeLogin?: boolean
  rememberMe:boolean
  reCaptchaToken:string
}

export const loginFormConstraints: FormConstraints<LoginForm> = {
  emailAddress: {
    presence: true,
    format: {
      // eslint-disable-next-line max-len
      pattern: /^[a-z0-9][a-z0-9-_.]+@([a-z]|[a-z0-9]?[a-z0-9-]+[a-z0-9])\.[a-z0-9]{2,10}(?:\.[a-z]{2,10})?$/
    }
  },
  password: {
    presence: true,
    length: {
      minimum: 2
    }
  },
  reCaptchaToken: {
    presence: true,
    length: {
      minimum: 2
    }
  }
}
